/**
 * @file Anything that can run on every page.
 */

import vContactForm from '../components/contact-form/contact-form';
import vContentBar from '../components/content-bar/content-bar';
import vFloatContent from '../components/float-content/float-content';
import vHeader from '../components/header/header';
import vImageScroller from '../components/image-scroller/image-scroller';
import vIntroImage from '../components/intro-image/intro-image';
import vTeamCarousel from '../components/team-carousel/team-carousel';
import vTestimonials from '../components/testimonials/testimonials';
import vLogoList from '../components/logo-list/logo-list';
import vLeaderList from '../components/leader-list/leader-list';
import vExpandableContent from '../components/expandable-content/expandable-content';
import vFloatCta from '../components/float-cta/float-cta';
import vBenefits from '../components/benefits/benefits';

/**
 * Global functions.
 *
 * Runs component js and any global tasks.
 */
const vGlobal = () => {
	vHeader();
	vContactForm();
	vImageScroller();
	vIntroImage();
	vContentBar();
	vFloatContent();
	vTeamCarousel();
	if (!wpPostData.isFrontPage) {
		vTestimonials();
	}
	vLogoList();
	vLeaderList();
	vExpandableContent();
	vFloatCta();
	vBenefits();

	const selects = document.querySelectorAll('select');
	[...selects].forEach((select) => {
		const selectParent = select.parentNode;
		if (selectParent.classList.contains('v-form__select')) {
			return;
		}

		const wrapper = document.createElement('span');
		const arrow   = document.createElement('span');
		wrapper.classList.add('v-form__select');
		arrow.classList.add('v-form__select-arrow');
		selectParent.insertBefore(wrapper, select);
		wrapper.appendChild(select);
		wrapper.appendChild(arrow);
		select.classList.add('v-form__select-field');
	});

	/**
	 * Global Window Load.
	 *
	 * Runs polyfills on page load.
	 */
	async function onWindowLoad() {
		const body = document.querySelector('body');
		if (!body.classList.contains('admin-bar')) {
			const { listen } = await import(/* webpackExports: "listen" */ 'quicklink');

			listen({
				ignores: [
					(url) => {
						const cleanUrl = url.replace(/#.*/, '');
						return cleanUrl === window.location.href;
					},
					/.*\/wp-admin\/.*/,
				],
			});
		}
	}

	if (document.readyState === 'complete') {
		onWindowLoad();
	} else {
		window.addEventListener('load', onWindowLoad);
	}
};

if (document.readyState !== 'loading') {
	vGlobal();
} else {
	document.addEventListener('DOMContentLoaded', vGlobal);
}
